export const PLAYER_REWARDS_TOGGLE_EVENT = 'player-rewards-toggle-event'; 